document.addEventListener('click', (e) => {
    if (e.target.closest('.testimonial-item')) {
        const testimonialItem = e.target.closest('.testimonial-item')
        if (testimonialItem.classList.contains('active')) {
            return
        }

        const testimonialItems = document.querySelectorAll('.testimonial-item')
        testimonialItems.forEach((item) => {
            item.classList.remove('active', 'activate', 'show')
            if (window.innerWidth < 1024) {
                item.style.height = '80px'
            } else {
                item.style.height = 'auto'
            }
        })

        if (window.innerWidth < 1024) {
            testimonialItem.style.height = `${testimonialItem.scrollHeight + 48}px`

            setTimeout(() => {
                testimonialItem.classList.add('active')
            }, 300)
        } else {
            testimonialItem.classList.add('active')
        }

        setTimeout(() => {
            testimonialItem.classList.add('activate')
        }, 600)

        setTimeout(() => {
            testimonialItem.classList.add('show')
        }, 800)
    }
})

document.addEventListener('DOMContentLoaded', () => {
    const testimonialItems = document.querySelectorAll('.testimonial-item')

    if (testimonialItems.length > 0) {
        document.querySelector('.testimonial-item').classList.add('active', 'activate', 'show')
    }
})
